/* eslint-disable */


import {
    ADD_CART_ITEM_REQUEST,
    ADD_FAVORITE_FAILED,
    ADD_FAVORITE_REQUEST,
    ADD_FAVORITE_SUCCESS,
    FETCH_CART_FAILED,
    FETCH_CART_SUCCESS,
    FETCH_FAVORITES_FAILED,
    FETCH_FAVORITES_REQUEST,
    FETCH_FAVORITES_SUCCESS, REMOVE_FAVORITE_FAILED, REMOVE_FAVORITE_REQUEST, REMOVE_FAVORITE_SUCCESS,
    SET_ERRORS
} from "../mutationTypes";
import FavoriteApi from "@shared/_api/favorite";
import ShoppingCartApi from "@shared/_api/shoppingCart";

const state = {
    favorites: [],
    loadingFavorites: false,
};

const getters = {
    favorites: (state) => state.favorites,
};

const actions = {
    fetchFavorites({commit, rootState}) {
        if(rootState.account.user) {
            commit(FETCH_FAVORITES_REQUEST);

            return FavoriteApi.all().then(favorites => {
                commit(FETCH_FAVORITES_SUCCESS, favorites);
            }).catch(error => {
                console.log(error);
            })
        }
    },
    addFavorite({commit}, {favoriteItem}) {
        commit(ADD_FAVORITE_REQUEST);

        return FavoriteApi.add(favoriteItem).then((favorites) => {
            commit(ADD_FAVORITE_SUCCESS, favorites);
            return favorites;
        }).catch(error => {
            console.log(error);
            commit(ADD_FAVORITE_FAILED);
        })
    },
    removeFavorite({commit}, {id}) {
        commit(REMOVE_FAVORITE_REQUEST);

        return FavoriteApi.delete(id).then((favorites) => {
            commit(REMOVE_FAVORITE_SUCCESS, favorites);
            return favorites;
        }).catch(error => {
            console.log(error);
            commit(REMOVE_FAVORITE_FAILED);
        })
    },
};

const mutations = {
    [FETCH_FAVORITES_SUCCESS](state, favorites) {
        state.favorites = favorites;
        state.loadingFavorites = false;
    },
    [ADD_FAVORITE_REQUEST](state) {
        state.loadingFavorites = true;
    },
    [REMOVE_FAVORITE_REQUEST](state) {
        state.loadingFavorites = true;
    },
    [REMOVE_FAVORITE_SUCCESS](state, favorites) {
        state.favorites = favorites;
        state.loadingFavorites = false;
    },
    [ADD_FAVORITE_SUCCESS](state, favorites) {
        state.favorites = favorites;
        state.loadingFavorites = false;
    },
    [FETCH_FAVORITES_REQUEST](state) {
        state.loadingFavorites = true;
    },
    [FETCH_FAVORITES_FAILED](state) {
        state.loadingFavorites = false;
    }

};

export const favorites = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};